<template lang="html">
  <b-container>
    <div>
      <vs-tabs :color="colorx">
        <vs-tab label="Hammasi" @click="colorx = '#8B0000'">
          <b-card style="border-radius:20px;">
            <b-row>
              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Number") }} </label>

                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
              <b-col sm="3">
                <div>
                  <b-col sm="3">
                    <label>{{ $t("Check") }} </label>
                  </b-col>
                  <b-form-checkbox
                    size="lg"
                    class="text-left"
                    style="margin-left:20px"
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("docdate") }}</label>

                  <date-picker
                    style="width:100%"
                    size="sm"
                    lang="ru"
                    :placeholder="$t('date')"
                    value-type="format"
                    format="DD.MM.YYYY"
                  ></date-picker>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("docname") }}</label>
                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Number") }} </label>

                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
              <b-col sm="3">
                <div>
                  <b-col sm="3">
                    <label>{{ $t("Check") }} </label>
                  </b-col>
                  <b-form-checkbox
                    size="lg"
                    class="text-left"
                    style="margin-left:20px"
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("docdate") }}</label>

                  <date-picker
                    style="width:100%"
                    size="sm"
                    lang="ru"
                    :placeholder="$t('date')"
                    value-type="format"
                    format="DD.MM.YYYY"
                  ></date-picker>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Select") }}</label>
                  <b-form-select
                    v-model="selected"
                    :options="options"
                  ></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Number") }} </label>

                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
              <b-col sm="3">
                <div>
                  <b-col sm="3">
                    <label>{{ $t("Check") }} </label>
                  </b-col>
                  <b-form-radio
                    class="text-left"
                    style="margin-left:20px"
                    name="radio-size"
                    size="lg"
                  ></b-form-radio>
                </div>
              </b-col>

              <b-col sm="3">
                <div>
                  <label>{{ $t("Check") }}</label>

                  <b-form-radio
                    class="text-left"
                    name="radio-size"
                    size="lg"
                  ></b-form-radio>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Select") }}</label>
                  <b-form-select
                    v-model="selected"
                    :options="options"
                  ></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="text-right">
                  <vs-button color="success" style="outline:none" type="border"
                    >Primary</vs-button
                  >
                </div>
              </b-col>
              <b-col>
                <div class="text-left">
                  <vs-button color="danger" style="outline:none" type="border"
                    >Primary</vs-button
                  >
                </div>
              </b-col>
            </b-row>
          </b-card>
        </vs-tab>
        <vs-tab label="Mahalliy hokimiyat" @click="colorx = '#FFA500'">
          <b-card style="border-radius:20px;">
            <b-row>
              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Number") }} </label>

                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
              <b-col sm="3">
                <div>
                  <b-col sm="3">
                    <label>{{ $t("Check") }} </label>
                  </b-col>
                  <b-form-checkbox
                    size="lg"
                    class="text-left"
                    style="margin-left:20px"
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("docdate") }}</label>

                  <date-picker
                    style="width:100%"
                    size="sm"
                    lang="ru"
                    :placeholder="$t('date')"
                    value-type="format"
                    format="DD.MM.YYYY"
                  ></date-picker>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("docname") }}</label>
                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Number") }} </label>

                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
              <b-col sm="3">
                <div>
                  <b-col sm="3">
                    <label>{{ $t("Check") }} </label>
                  </b-col>
                  <b-form-checkbox
                    size="lg"
                    class="text-left"
                    style="margin-left:20px"
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("docdate") }}</label>

                  <date-picker
                    style="width:100%"
                    size="sm"
                    lang="ru"
                    :placeholder="$t('date')"
                    value-type="format"
                    format="DD.MM.YYYY"
                  ></date-picker>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Select") }}</label>
                  <b-form-select
                    v-model="selected"
                    :options="options"
                  ></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Number") }} </label>

                  <b-form-input type="number"></b-form-input>
                </div>
              </b-col>
              <b-col sm="3">
                <div>
                  <b-col sm="3">
                    <label>{{ $t("Check") }} </label>
                  </b-col>
                  <b-form-radio
                    class="text-left"
                    style="margin-left:20px"
                    name="radio-size"
                    size="lg"
                  ></b-form-radio>
                </div>
              </b-col>

              <b-col sm="3">
                <div>
                  <label>{{ $t("Check") }}</label>

                  <b-form-radio
                    class="text-left"
                    name="radio-size"
                    size="lg"
                  ></b-form-radio>
                </div>
              </b-col>

              <b-col sm="3">
                <div class="form-group form-row">
                  <label>{{ $t("Select") }}</label>
                  <b-form-select
                    v-model="selected"
                    :options="options"
                  ></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="text-right">
                  <vs-button color="success" style="outline:none" type="border"
                    >Primary</vs-button
                  >
                </div>
              </b-col>
              <b-col>
                <div class="text-left">
                  <vs-button color="danger" style="outline:none" type="border"
                    >Primary</vs-button
                  >
                </div>
              </b-col>
            </b-row>
          </b-card>
        </vs-tab>
        <vs-tab label="Xalqaro" @click="colorx = '#551A8B'">
          <b-card></b-card>
        </vs-tab>
        <vs-tab label="Texnik" @click="colorx = '#0000FF'">
          <b-card></b-card>
        </vs-tab>
      </vs-tabs>
    </div>
  </b-container>
</template>
<script>
export default {
  data: () => ({
    colorx: "#8B0000",
  }),
};
</script>
<style>
.vs-tabs--btn {
  outline: none !important;
}
</style>
